// 요약
export const STATISTICS_SUMMARY_LIST_REQUEST = 'STATISTICS_SUMMARY_LIST_REQUEST';

// 재무

// 토큰
export const STATISTICS_TOKEN_LIST_REQUEST = 'STATISTICS_TOKEN_LIST_REQUEST';

export const STATISTICS_TOKEN_EXCEL_DATA_REQUEST = 'STATISTICS_TOKEN_EXCEL_DATA_REQUEST';

// 마켓
export const STATISTICS_CAR_LIST_REQUEST = 'STATISTICS_CAR_LIST_REQUEST';

export const STATISTICS_CAR_EXCEL_DATA_REQUEST = 'STATISTICS_CAR_EXCEL_DATA_REQUEST';

export const STATISTICS_CAR_BOX_LIST_REQUEST = 'STATISTICS_CAR_BOX_LIST_REQUEST';

export const STATISTICS_CAR_BOX_EXCEL_DATA_REQUEST = 'STATISTICS_CAR_BOX_EXCEL_DATA_REQUEST';

export const STATISTICS_ITEMS_LIST_REQUEST = 'STATISTICS_ITEMS_LIST_REQUEST';

export const STATISTICS_ITEMS_EXCEL_DATA_REQUEST = 'STATISTICS_ITEMS_EXCEL_DATA_REQUEST';

export const STATISTICS_GEM_LIST_REQUEST = 'STATISTICS_GEM_LIST_REQUEST';

export const STATISTICS_GEM_EXCEL_DATA_REQUEST = 'STATISTICS_GEM_EXCEL_DATA_REQUEST';

// NFT
export const STATISTICS_NFT_CAR_LIST_REQUEST = 'STATISTICS_NFT_CAR_LIST_REQUEST';

export const STATISTICS_NFT_CAR_EXCEL_DATA_REQUEST = 'STATISTICS_NFT_CAR_EXCEL_DATA_REQUEST';

export const STATISTICS_NFT_LEVEL_STAT_LIST_REQUEST = 'STATISTICS_NFT_LEVEL_STAT_LIST_REQUEST';

export const STATISTICS_NFT_LEVEL_EXCEL_DATA_REQUEST = 'STATISTICS_NFT_LEVEL_EXCEL_DATA_REQUEST';

export const STATISTICS_NFT_STAT_EXCEL_DATA_REQUEST = 'STATISTICS_NFT_STAT_EXCEL_DATA_REQUEST';

export const STATISTICS_NFT_BOX_LIST_REQUEST = 'STATISTICS_NFT_BOX_LIST_REQUEST';

export const STATISTICS_NFT_BOX_EXCEL_DATA_REQUEST = 'STATISTICS_NFT_BOX_EXCEL_DATA_REQUEST';

// 아이템
export const STATISTICS_ITEM_ITEMS_LIST_REQUEST = 'STATISTICS_ITEM_ITEMS_LIST_REQUEST';

export const STATISTICS_ITEM_ITEMS_EXCEL_DATA_REQUEST = 'STATISTICS_ITEM_ITEMS_EXCEL_DATA_REQUEST';

// 유저
export const STATISTICS_USER_LIST_REQUEST = 'STATISTICS_USER_LIST_REQUEST';
